import AdminMainPage from './subPages/main';
import ShoppingCenterPages from './subPages/shoppingCenter';
import AgentsPages from './subPages/agents';
import ClickCollectPage from '../clickCollect';
import CompanyCategories from './subPages/companyCategories';
import SiteCategories from './subPages/siteCategories';
import CompanyCategoriesDocumentPages from '../documents/subPages/companyDocumentCategories';
import CompanyChildCategoriesPages from './subPages/companyChildCategories';
import PrestigeLevelsPages from './subPages/prestigeLevels';
import CompaniesPages from './subPages/companies';
import Pages from './subPages/pages';
import ChainsPages from './subPages/chains';
import LogsPages from './subPages/logs';
import FootfallsPages from './subPages/footfalls';
import CalendarsPages from './subPages/calendars';
import ChooseCompanyPage from './subPages/chooseCompany';
//import NotificationsPages from './subPages/notifications';

const routes = [
  {
    path: 'shopping_centers/*',
    canUse: [],
    Component: ShoppingCenterPages,
  },
  {
    path: 'agents/*',
    canUse: [],
    Component: AgentsPages,
  },
  {
    path: 'click_collect/*',
    canUse: [],
    Component: ClickCollectPage,
  },
  {
    path: 'company_categories/*',
    canUse: [],
    Component: CompanyCategories,
  },
  {
    path: 'site_categories/*',
    canUse: [],
    Component: SiteCategories,
  },
  {
    path: 'company_document_categories/*',
    canUse: [],
    Component: CompanyCategoriesDocumentPages,
  },
  {
    path: 'company_child_categories/*',
    canUse: [],
    Component: CompanyChildCategoriesPages,
  },
  {
    path: 'prestige_levels/*',
    canUse: [],
    Component: PrestigeLevelsPages,
  },
  {
    path: 'companies/*',
    canUse: [],
    Component: CompaniesPages,
  },
  {
    path: 'pages/*',
    canUse: [],
    Component: Pages,
  },
  {
    path: 'chains/*',
    canUse: [],
    Component: ChainsPages,
  },
  {
    path: 'gdprlogs/*',
    canUse: [],
    Component: LogsPages,
  },
  {
    path: 'footfalls/*',
    canUse: [],
    Component: FootfallsPages,
  },
  {
    path: 'calendars/*',
    canUse: [],
    Component: CalendarsPages,
  },
  {
    path: 'choose_companies/*',
    canUse: [],
    Component: ChooseCompanyPage,
  },
  // {
  //   path: 'notifications/*',
  //   canUse: [],
  //   Component: NotificationsPages,
  // },
];

export default routes;
